import React from 'react';
import styled from '@emotion/styled';
import { scaleImage } from '@nykaa/utils/image';
import LazyLoad from '@nykaa/lazy-load';
import { EAGER_LOAD_IMAGES, EAGER_LOAD_INVENTORIES } from '@nykaa/deals-utils/images/constants';
import AnchorTag from '../AnchorTag';
const ImagePlaceHolder = styled.div `
  width: 100%;
  min-height: ${({ minHeight }) => minHeight}px;
`;
const Wrapper = styled.div `
  min-height: ${({ minHeight }) => minHeight}px;

  img {
    display: inline-block;
    width: 100%;
    vertical-align: bottom;
    min-height: ${({ minHeight }) => minHeight}px;
  }
`;
const ImgTag = ({ imgUrl, largerImgUrl, alt, url, }) => (React.createElement(AnchorTag, { url: url },
    React.createElement("img", { src: imgUrl, alt: alt, loading: "eager", srcSet: `${largerImgUrl} 2x` })));
const Image = (widgetData) => {
    let maxWidth = 600;
    let minWidth = 360;
    const { params, inventoryPosition, parentPosition: tilePosition, eagerLoadImages = EAGER_LOAD_IMAGES, eagerLoadInventories = EAGER_LOAD_INVENTORIES, isDesktop, id, trackingData, } = widgetData;
    if (isDesktop) {
        maxWidth = 1200;
        minWidth = 1000;
    }
    const { src, columnsInRow, aspectRatio, childWidth, altText, url, } = params;
    let height = 50;
    const eagerLoading = (tilePosition <= eagerLoadImages)
        && (inventoryPosition <= eagerLoadInventories);
    const width = (maxWidth / (columnsInRow || 1));
    const { namespace2 } = trackingData;
    const alt = altText || namespace2 || 'banner image';
    if (!childWidth) {
        const mWidth = (minWidth / (columnsInRow || 1));
        height = Math.round((mWidth / (aspectRatio || mWidth)));
    }
    if (!src) {
        return '';
    }
    const imgUrl = scaleImage({
        url: src,
        width,
    });
    const largerImgUrl = scaleImage({
        url: src,
        width: (width * 2),
    });
    return (React.createElement(Wrapper, { minHeight: height, className: "image-wrapper", id: id }, eagerLoading ? (React.createElement(ImgTag, { imgUrl: imgUrl, largerImgUrl: largerImgUrl, widthImg: width, heightImg: height, alt: alt, url: url, eagerLoading: eagerLoading })) : (React.createElement(LazyLoad, { placeHolder: React.createElement(ImagePlaceHolder, { minHeight: height }), bottomMargin: 0, wrapperClassName: "img-wrap" },
        React.createElement(ImgTag, { imgUrl: imgUrl, largerImgUrl: largerImgUrl, widthImg: width, heightImg: height, alt: alt, url: url, eagerLoading: eagerLoading })))));
};
export default Image;
